module.exports = __webpack_public_path__ + "static/media/iconomeinteresamagenta.85c16f83.svg";